import React from 'react';
import { Eye, Edit, Trash2, Layers, Calendar } from 'lucide-react';
import CuttingPlanStatusBadge from './CuttingPlanStatusBadge';

const CuttingPlanCard = ({ plan, onView, onEdit, onDelete }) => {
  const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString('pt-BR');
  };

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 hover:shadow-md transition-shadow">
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <div className="flex items-center gap-3 mb-2">
            <h3 className="font-semibold text-gray-900">
              {plan.plan_code}
            </h3>
            <CuttingPlanStatusBadge status={plan.status} size="sm" />
          </div>

          <div className="space-y-1 text-sm text-gray-600">
            <div className="flex items-center gap-2">
              <Layers className="w-4 h-4" />
              <span>{plan.project_name || `Projeto #${plan.project_id}`}</span>
            </div>
            {plan.cut_plan_date && (
              <div className="flex items-center gap-2">
                <Calendar className="w-4 h-4" />
                <span>Corte: {formatDate(plan.cut_plan_date)}</span>
              </div>
            )}
          </div>
        </div>

        <div className="flex items-center gap-2">
          <button
            onClick={() => onView?.(plan)}
            className="p-2 text-gray-500 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors"
            title="Visualizar"
          >
            <Eye className="w-5 h-5" />
          </button>
          <button
            onClick={() => onEdit?.(plan)}
            className="p-2 text-gray-500 hover:text-green-600 hover:bg-green-50 rounded-lg transition-colors"
            title="Editar"
          >
            <Edit className="w-5 h-5" />
          </button>
          <button
            onClick={() => onDelete?.(plan)}
            className="p-2 text-gray-500 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors"
            title="Excluir"
          >
            <Trash2 className="w-5 h-5" />
          </button>
        </div>
      </div>

      <div className="mt-3 pt-3 border-t border-gray-100 grid grid-cols-3 gap-4 text-center">
        <div>
          <p className="text-xs text-gray-500">Dimensões</p>
          <p className="text-sm font-medium text-gray-900">
            {plan.board_width}x{plan.board_height}m
          </p>
        </div>
        <div>
          <p className="text-xs text-gray-500">Kerf</p>
          <p className="text-sm font-medium text-gray-900">{plan.kerf_width}mm</p>
        </div>
        <div>
          <p className="text-xs text-gray-500">Eficiência</p>
          <p className="text-sm font-medium text-gray-900">
            {plan.efficiency_percentage ? `${plan.efficiency_percentage}%` : '-'}
          </p>
        </div>
      </div>
    </div>
  );
};

export default CuttingPlanCard;
